import React from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';

import { normalize } from 'polished';
import { StaticQuery, graphql } from 'gatsby';

import systemFont from '../system-font.jsx';
import theme from '../theme';
import Header, { DocHeader } from './Header.jsx';

const TextBody = styled.div`
  width: 100%;
  max-width: 37em;
  margin: 0 auto;
  padding: 2em;
  padding-top: 0;
`;

const Body = styled.div`
  min-width: 100%;
  min-height: 100vh;

  padding-top: 65px;

  margin: 0;

  display: flex;
  flex-direction: column;

  transition: all 300ms ease-out;
`;

const GlobalStyle = createGlobalStyle`
  ${normalize()}
  ${systemFont()}

  html, body {
    box-sizing: border-box;
    color: #444;
    fill: #444;
    scroll-behavior: smooth;
  }

  a {
    color: ${theme.palette.primary[0]};
  }

  *[id]:before {
    display: block;
    content: " ";
    margin-top: -65px; // Set the Appropriate Height
    height: 65px; // Set the Appropriate Height
    visibility: hidden;
  }

  ul {
    padding-left: 20px;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
`;

const titleQuery = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

const titleQuery2 = graphql`
  query SiteTitleQuery2 {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

export const MainLayout = ({ lang, children, main = false }) => (
  <StaticQuery
    query={titleQuery}
    render={data => (
      <>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
          {main ? (
            <>
              <Header lang={lang} siteTitle={data.site.siteMetadata.title} />
              <Body>{children}</Body>
            </>
          ) : (
            <>
              <DocHeader lang={lang} siteTitle={data.site.siteMetadata.title} />
              <Body>
                <TextBody>{children}</TextBody>
              </Body>
            </>
          )}
        </ThemeProvider>
      </>
    )}
  />
);

export default MainLayout;
